import { useModalStore } from 'common/hooks/useModals';
import CreateAccountModal from 'account/components/CreateAccountModal';
import AddAircraftModal from 'aircraft/components/AddAircraftModal';
import TransferDeactivatedAircraft from 'aircraft/components/TransferDeactivatedAircraftModal';
import ChangeRegistrationModal from 'aircraft/components/ChangeRegistrationModal';
import AddAccountUserModal from 'accountUsers/components/AddAccountUserModal';
import EditAccountUserInfoModal from 'accountUsers/components/EditAccountUserInfoModal';
import { ThemeProvider } from '@emotion/react';
import ModifyAccountUserAircraftAssignmentsModal
  from '../../accountUsers/components/ModifyAccountUserAircraftAssignmentsModal';
import ModifyAccountUserFleetAssignmentsModal
  from '../../accountUsers/components/ModifyAccountUserFleetAssignmentsModal';
import nutailTheme from '../theme/NutailTheme';

function View({
  showCreateAccount,
  showAddAircraft,
  showTransferDeactivatedAircraft,
  showChangeRegistration,
  showAddAccountUser,
  showEditAccountUser,
  showModifyAircraftAssignments,
  showModifyFleetAssignments,
}) {
  return (
    <>
      {showCreateAccount && (
        <CreateAccountModal />
      )}
      {showAddAircraft && (
        <AddAircraftModal />
      )}
      {showTransferDeactivatedAircraft && (
        <TransferDeactivatedAircraft />
      )}
      {showChangeRegistration && (
        <ChangeRegistrationModal />
      )}
      {showAddAccountUser && <AddAccountUserModal />}
      {showEditAccountUser && <EditAccountUserInfoModal />}
      {showModifyAircraftAssignments && <ModifyAccountUserAircraftAssignmentsModal />}
      {showModifyFleetAssignments && <ModifyAccountUserFleetAssignmentsModal />}
    </>
  );
}

function Model() {
  const {
    createAccount,
    addAircraft,
    transferDeactivatedAircraft,
    changeRegistration,
    addAccountUser,
    editAccountUser,
    modifyAircraftAssignments,
    modifyFleetAssignments,
  } = useModalStore();

  const hookProps = {
    showCreateAccount: createAccount.isOpen,
    showAddAircraft: addAircraft.isOpen,
    showTransferDeactivatedAircraft: transferDeactivatedAircraft.isOpen,
    showChangeRegistration: changeRegistration.isOpen,
    showAddAccountUser: addAccountUser.isOpen,
    showEditAccountUser: editAccountUser.isOpen,
    showModifyAircraftAssignments: modifyAircraftAssignments.isOpen,
    showModifyFleetAssignments: modifyFleetAssignments.isOpen,
  };

  return (
    <ThemeProvider theme={nutailTheme}>
      <View
        {...hookProps}
      />
    </ThemeProvider>
  );
}

export default Model;
export { View };
